export default {
  name: "BDDM",
  components: {},
  props: [
    "title",
    "subtitle",
    "selectedItems",
    "items",
    "selectedIcon",
    "unselectedIcon",
    "nameProp",
    "hideIcon",
    "idProp",
    "saveOnChange",
    "addPath",
    "deletePath",
    "dbIdProp1",
    "dbIdProp2",
    "dbIdValue1",
    "skipSaveMessage",
    "nameInjection",
    "nameProp2"
  ],
  data() {
    return {
      inited: false,
      sIcon: "fas fa-check-circle",
      usIcon: "far fa-circle",
      visible: false
    };
  },
  beforeDestroy() {
    document.removeEventListener("click", this.OutsideClick);
  },
  computed: {},
  mounted() {
    if (this.selectedIcon && this.selectedIcon != "") {
      this.sIcon = this.selectedIcon;
    }

    if (this.unselectedIcon && this.unselectedIcon != "") {
      this.usIcon = this.unselectedIcon;
    }
  },
  methods: {
    OutsideClick(event) {
      let ddl = this.$refs["BDDM"];
      if (!ddl.contains(event.target)) {
        this.visible = false;
        document.removeEventListener("click", this.OutsideClick);
      }
    },

    Show() {
      this.SyncSelectedItems();

      this.$set(this, "visible", !this.visible);
      document.addEventListener("click", this.OutsideClick);
    },

    Hide() {
      this.$nextTick(() => {
        this.$emit("update:visible", false);
      });
    },

    SyncSelectedItems() {
      this.$nextTick(() => {
        for (let item of this.items) {
          let found = this.selectedItems.find(
            x =>
              this.$helpers.GetProp(x, this.idProp) ===
              this.$helpers.GetProp(item, this.idProp)
          );

          if (found) {
            this.$set(item, "selected", true);
          } else {
            this.$set(item, "selected", false);
          }
        }
      });
    },

    GetProp(item, prop) {
      let value = this.$helpers.GetProp(item, prop);
      if (typeof value === "number" && value.toString().length === 13) {
        value = new Date(value).toLocaleDateString();
      }

      return value;
    },

    UpdateSelectedItem(obj) {
      this.$nextTick(() => {
        this.$set(obj, "selected", !obj.selected);
        let found = this.selectedItems.find(
          x =>
            this.$helpers.GetProp(x, this.idProp) ===
            this.$helpers.GetProp(obj, this.idProp)
        );

        if (!found && obj.selected) {
          this.selectedItems.push(obj);
          this.$emit("added", obj);

          if (this.saveOnChange) {
            this.SaveChange(
              this.addPath,
              this.$helpers.GetProp(obj, this.idProp)
            );
          }
        } else if (found && !obj.selected) {
          let i = this.selectedItems.indexOf(found);
          this.selectedItems.splice(i, 1);
          this.$emit("removed", found);
          if (this.saveOnChange) {
            this.SaveChange(
              this.deletePath,
              this.$helpers.GetProp(obj, this.idProp)
            );
          }
        }
      });
    },
    async SaveChange(path, value) {
      this.$emit("saving", "success");

      this.$helpers
        .PostApi(path, {
          [this.dbIdProp1]: this.dbIdValue1,
          [this.dbIdProp2]: value
        })
        .then(res => {
          this.SaveSuccess(res);
        })
        .catch(err => {
          this.SaveError(`Save failed: Error code ${err.response.status}`);
        });
    },
    SaveSuccess(res) {
      if (!this.skipSaveMessage) {
        this.$helpers.ShowStatus(`Saved`, 1000);
      }

      this.$emit("saved", {
        error: false,
        result: res
      });
    },
    SaveError(message) {
      if (!this.skipSaveMessage) {
        this.$helpers.ShowStatus(message, 0, "warning");
      }

      this.$emit("input", this.originalValue);
    }
  }
};
